var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page-wrapper"},[(_vm.switch_tab == 'overview')?_c('Overview',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'events')?_c('Events',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'projects')?_c('Projects',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'account-contact')?_c('AccountContacts',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'lia-generation')?_c('LiaGeneration',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'attachments')?_c('Attachments',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'notes')?_c('Notes',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e(),(_vm.switch_tab == 'activities')?_c('Activities',{on:{"tab":(tab) => {
    _vm.switch_tab = tab;
  }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }